import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';

import { BeeBackButtonModule } from '@bee-components/bee-back-button/bee-back-button.module';

import { Bee404Component } from './bee-404.component';

@NgModule({
  declarations: [
    Bee404Component
  ],
  imports: [
    CommonModule,
    BeeBackButtonModule,
    FlexLayoutModule,
  ],
  exports: [
    Bee404Component
  ]
})
export class Bee404Module { }
